import { viewFetch as fetch } from '../view-as.js';
import { ApiError, Unauthenticated, type Store } from '../api.js';

export interface ClearedDecision {
  decisionId: string;
  passItemId: string | null;
  headline: string | null;
  subjectKind: string;
  subjectId: string;
  action: string;
  optionLabel: string | null;
  decidedAt: string;
  undoUntil: string;
  undo: 'undo' | 'sent' | 'calendar' | 'call' | 'told';
}
export type ClearedRow = ClearedDecision & { store: Store };

async function answer<T>(response: Response): Promise<T> {
  if (response.status === 401) throw new Unauthenticated();
  if (!response.ok) {
    const body = await response.json().catch(() => null) as { error?: string } | null;
    throw new ApiError(response.status, body?.error ?? 'The cleared cards could not be read.');
  }
  return response.json() as Promise<T>;
}

/** Stores remain separate requests; merging orders the person's own history across the visible stores. */
export async function readCleared(stores: Store[], signal: AbortSignal): Promise<ClearedRow[]> {
  const rows = await Promise.all(stores.map(async (store) => {
    const response = await fetch(`/api/triage/cleared?store=${encodeURIComponent(store.tenantId)}`, { credentials: 'same-origin', signal });
    const result = await answer<{ items: ClearedDecision[] }>(response);
    return result.items.map((item) => ({ ...item, store }));
  }));
  return rows.flat().sort((a, b) => Date.parse(b.decidedAt) - Date.parse(a.decidedAt));
}

export async function undoCleared(row: ClearedRow): Promise<void> {
  await answer(await fetch(`/api/triage/decisions/${encodeURIComponent(row.decisionId)}/undo`, {
    method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ store: row.store.tenantId }),
  }));
}
